<template>
  <ul>
    <learning-resource-vue
      v-for="r in resources"
      :key="r.id"
      :id="r.id"
      :title="r.title"
      :description="r.description"
      :link="r.link"
      >{{ r.title }}</learning-resource-vue
    >
  </ul>
</template>

<script>
import LearningResourceVue from './LearningResource.vue';
export default {
  components: { LearningResourceVue },
  inject: { resources: { type: Array, required: true } },
  data() {
    return {};
  },
};
</script>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  margin: auto;
  max-width: 40rem;
}
</style>
